<template>
    <FormCard>
        <template #cardTitle>
            Medical Provider's Information
        </template>
        <template #cardSubtitle>
            Please enter the information about the medical provider.
        </template>
        <template #cardText>
            <v-autocomplete
                v-model.trim="from.hosp2"
                :auto-select-first="true"
                color="#009688"
                autocomplete="nope"
                return-object
                item-text="hosp_name"
                :items="from.hospItems2"
                :rules="[v=>!!v||'Name of Hospital or Clinic is required']"
            >
                <template #label>
                    <span style="font-weight: 500; color: black;">Name of Hospital or Clinic</span>
                </template>
            </v-autocomplete>
        </template>
    </FormCard>
</template>

<script>
import FormCard from './InputComp/FormCard.vue'

export default {
    components: {
        FormCard
    },
    props: ['hospItems2', 'hosp2'],
    data: ()=>({
        from: {
            hosp2: null,
            hospItems2: []
        }
    }),
    watch: {
        hosp2(newVal) {
            if (newVal) this.from.hosp2 = newVal
        },
        hospItems2(newVal) {
            if (newVal) this.from.hospItems2 = newVal
        },
        'from.hosp2': {
            handler(newVal) {
                this.$emit('setHosp2', newVal)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
